export function planRunIds(doc) {
    const scotia = [];
    const trims = {};
    for (const [fi, f] of (doc.assessment.plan ?? []).entries()) {
        for (const r of f.skirting?.rooms ?? [])
            if (r.scotia_m > 0 && r.area_id)
                scotia.push(`scotia:${fi}:${r.area_id}`);
        for (const t of f.trims ?? []) {
            if (!t.id || /scotia|skirting/i.test(t.kind))
                continue;
            const key = (t.profile || t.kind).trim().toLowerCase();
            (trims[key] ??= []).push(t.id);
        }
    }
    return { scotia, trims };
}
/** The run ids a row that follows the measure claims: scotia by its rooms, a drawn-profile trim by its profile; nothing else. */
export function accessoryRunIds(a, ids) {
    if (a.quantity_source !== 'assessment')
        return [];
    if (a.kind === 'scotia')
        return ids.scotia;
    if (a.kind === 'trims' && a.trim_profile)
        return ids.trims[a.trim_profile.trim().toLowerCase()] ?? [];
    return [];
}
//# sourceMappingURL=proposal-run-ids.js.map